<template>
  <div v-if="message.type === 'chatgpt'" class="message">
    <Avatar messageType="chatgpt" />
    <div :class="`message-content`">
      <div v-if="message.loading" class="message-loading">
        <div :id="`loading-id-${message.id}`"></div>
      </div>
      <div v-else-if="message.error" class="error">出错了：{{ message.error.msg }}，请重试</div>
      <div v-show="!message.loading" class="message-content-text" :id="`text-id-${message.id}`"></div>
    </div>
  </div>
  <div v-else class="message user" :key="message.id">
    <Avatar messageType="user" />
    <div class="message-content">
      <div class="message-content-text">
        {{ message.content }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from './Avatar.vue'

export default {
  name: 'ChatMessage',
  components: { Avatar },
  props: {
    message: {
      type: Object,
      default: () => ({
        type: 'chatgpt',
        loading: true,
        id: '',
        error: {
          msg: ''
        },
        content: ''
      })
    }
  },
  // 定义属性
  data() {
    return {}
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
}
</script>

<style lang="scss" scoped>

.message-loading {
  padding-bottom: 48px;
  display: flex;
}

.message {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 16px;
  // border-bottom: 1px solid #efefef;
  width: 100%;

  &:last-child {
    border: none;
    .message-content {
      padding-bottom: 96px;
    }
  }

  &.user {
    .message-content-text {
      color: #609966;
    }
  }

  .error {
    color: red;
  }

  .message-content {
    width: 100%;
    padding-top: 8px;
    display: flex;
    align-items: flex-end;
    flex: 1 1 auto;
    padding-bottom: 16px;
    .message-content-text {
      width: 100%;
      word-break: break-all;

      pre {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .content {
    width: 100% !important;
    padding: 0 16px;

    .message {
      flex-direction: column;
    }

    .avatar {
      font-size: 12px;
      width: 28px !important;
      height: 28px !important;
      border-radius: 2px !important;
      .chatgpt-avatar {
        border-radius: 2px !important;
      }
    }
  }
}

</style>
